import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CustomInput,
  Button,
} from '@polichat/flamboyant';
import { useState } from 'react';
import { useGlotaT } from '../../../../hooks/useGlotaTranslation';

import PoliZAPI from '../../../../assets/images/integrations/Poli_ZAPI.svg';
import PoliZAPIW from '../../../../assets/images/integrations/Poli_ZAPI_white.svg';

import styles from './style.module.css';
import { IconPlusIcon } from '../../../../assets/illustratorElement/iconPlusIcon/iconPlusIcon';
import { useWhiteLabel } from '../../../../hooks/useWhiteLabel';

interface ZapiModalProps {
  isOpen: boolean;
  isDarkMode: boolean;
  onClose: () => void;
  onSubmit: () => void;
  isFreeTrial: boolean;
}

export default function ZapiModal({
  isOpen,
  isDarkMode,
  onClose,
  onSubmit,
  isFreeTrial,
}: ZapiModalProps): JSX.Element {
  const [isChecked, setIsChecked] = useState(false);
  
  // Traduções
  const zapiTitle = useGlotaT('spa.integrations.zapi.title');
  const freeTrialMessage = useGlotaT('spa.integrations.zapi.freeTrialMessage');
  const cancel = useGlotaT('spa.integrations.zapi.cancel');
  const hire = useGlotaT('spa.integrations.zapi.hire');
  const externalChannelMessage = useGlotaT('spa.integrations.zapi.externalChannelMessage');
  const externalChannelMessagePoli = useGlotaT('spa.integrations.zapi.externalChannelMessagePoli');
  const externalChannelQuestion = useGlotaT('spa.integrations.zapi.externalChannelQuestion');
  const termsCheckbox = useGlotaT('spa.integrations.zapi.termsCheckbox');
  const continueLabel = useGlotaT('spa.integrations.zapi.continue');

  const handleAgree = () => {
    setIsChecked((state: any) => (state = !state));
  };

  const isWhiteLabel = useWhiteLabel();

  return (
    <>
      <Modal isOpen={isOpen} toggle={onClose}>
        <ModalHeader>
          <div className={styles.image_header}>
            <IconPlusIcon 
              firstIcon="onlyLogo"
              secondIcon="zApiIcon"
              secondColor="var(--success)"
            />
            {zapiTitle}
          </div>
        </ModalHeader>
        {isFreeTrial ? (
          <>
            <ModalBody>
              {freeTrialMessage}
            </ModalBody>
            <ModalFooter>
              <div className={styles.buttons_container}>
                <Button
                  gradient="danger"
                  className={styles.custom_button}
                  onClick={onClose}
                >
                  {cancel}
                </Button>
                <Button
                  className={styles.custom_button}
                  onClick={() => window.open('https://wa.me/556299800123')}
                >
                  {hire}
                </Button>
              </div>
            </ModalFooter>
          </>
        ) : (
          <>
            <ModalBody>
              {externalChannelMessage}
              {!isWhiteLabel.isWl && externalChannelMessagePoli}
              {externalChannelQuestion}
            </ModalBody>
            <ModalBody>
              <div className={styles.checkbox_container}>
                <CustomInput
                  type="checkbox"
                  id="show-widget-at-webchat"
                  label={termsCheckbox}
                  checked={isChecked}
                  onChange={handleAgree}
                />
              </div>
            </ModalBody>
            <ModalFooter>
              <div className={styles.buttons_container}>
                <Button
                  gradient="danger"
                  className={styles.custom_button}
                  onClick={onClose}
                >
                  {cancel}
                </Button>
                <Button
                  disabled={!isChecked}
                  onClick={onSubmit}
                  className={styles.custom_button}
                >
                  {continueLabel}
                </Button>
              </div>
            </ModalFooter>
          </>
        )}
      </Modal>
    </>
  );
}
